export default "__VITE_ASSET__BdaI2Ldy__"